import { keyframes } from 'styled-components';

export const blob1Wrapper = keyframes`
	0% {
		offset-distance: 0%;
	}
	50% {
		offset-distance: 50%;
	}
	100% {
		offset-distance: 100%;
	}
`;

export const blob1 = keyframes`
	0% {
		transform: rotate(-25deg);
	}
	100% {
		transform: rotate(335deg);
	}
`;

export const blob2 = keyframes`
	0% {
		offset-distance: 0%;
	}
	50% {
		offset-distance: 50%;
	}
	100% {
		offset-distance: 100%;
	}
`;

export const blob3Wrapper = keyframes`
	0% {
		offset-distance: 0%;
	}
	50% {
		offset-distance: 50%;
	}
	100% {
		offset-distance: 100%;
	}
`;

export const blob3 = keyframes`
	0% {
		transform: rotate(-46deg);
	}
	100% {
		transform: rotate(314deg);
	}
`;

export const blob4Wrapper = keyframes`
	0% {
		offset-distance: 0%;
	}
	32% {
		offset-distance: 33.333333%;
	}
	68% {
		offset-distance: 66.666667%;
	}
	100% {
		offset-distance: 100%;
	}
`;

export const blob4 = keyframes`
	0% {
		transform: rotate(86deg);
	}
	44% {
		transform: rotate(156.674243deg);
	}
	76% {
		transform: rotate(86deg);
	}
	100% {
		transform: rotate(86deg);
	}
`;
